import { render } from "./DeliverableView.vue?vue&type=template&id=327e10c0"
import script from "./DeliverableView.vue?vue&type=script&lang=js"
export * from "./DeliverableView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__